import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { mapBrandDtoToBrandModel } from '../../../shared/utils/mapping/mapping.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';
import { BrandDto } from '../dtos/brand.dto';
import { BrandModel } from '../models/brand.model';

export const getBrands: AsyncThunk<
  BrandModel[],
  void,
  Record<string, unknown>
> = createAsyncThunk('getFirmwareBrands', async () => {
  const mandantId = localStorageService.get(
    LocalStorageProperties.SELECTED_MANDANT
  ) as string | null;

  const url = createPathParams<'mandantId'>(Endpoints.GET_BRANDS, {
    ...(mandantId !== null && { mandantId: parseInt(mandantId, 10) }),
  });

  const { data }: AxiosResponse<BrandDto[]> = await axiosInstance.get(url);

  return data.map(mapBrandDtoToBrandModel);
});
